import { lazy } from 'react';
import { promiseRetry } from '@olxeu-a2b/delivery-utils/src/extras';

export const Confirmation = lazy(() =>
  promiseRetry(
    () => import(/* webpackChunkName: "order-confirmation" */ './components/Confirmation'),
    5,
    500,
  ),
);

export const ConfirmationSuccess = lazy(() =>
  promiseRetry(
    () =>
      import(
        /* webpackChunkName: "order-confirmation-success" */ './components/ConfirmationSuccessPage'
      ),
    5,
    500,
  ),
);
